import { Outlet } from "react-router-dom"
import { MarketingFooter, MarketingHeader } from "@/components/marketing"

export default function MarketingLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <MarketingHeader />
      <main className="flex-1 pt-20">
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  )
}
